/* 推送类型 */
export enum SOCKET_TYPE_ENUM {
  /** 心跳 */
  HEART_BEAT = 0,
  /** 业务数据 */
  BUSINESS = 1,
  /** 业务异常 */
  ERROR = 2,
}

export const H5_UPLOAD_PUBLIC_KEY = `MIICXQIBAAKBgQDKLC8nPEcABgBaJbpymhNhAVfTZiipAS7BTyAIfr3dXrAMA6Fy
t2WI+7Sh3Wc65xeVTA9L3nf0lA/4bV/hOped9Le7nBM/0dGg/4lPXFeCCpGXPaSh
YmmfXmYKleYZUvFU4PKYQHBcEhwW+4lQyG/VQU8riK9gs79JMJ9JI6DyoQIDAQAB
AoGBAJc+nrf3fBYkZzcJaoY5ha3YV1+q2Vg1rkinbQtt5ZQqNgGG5czwLmFgDC3b
eFK0dwwVrovPjmXGLnxnNodEUg9fUPIREPjVdT0Vzw/BKGowLVJVvFs8ooyOizsS
GMYQGAlFXLoVE/2FxQj90bkTQ73Fdgvw81kiUZPOY5FOvs8RAkEA9/ZTrivXV3cT
SXuFFrSU0U9TRp341Rty4pgNDCO8h1tNkmh96lKOuCN4cuW1qhx2VTC/y0iZVw6b
XkTkQ087LwJBANC54TmO4hr/ijUPnrPfOl+hCHyJS5/32HlsvJNeG9XPKmNU3gdt
jWOmID3vvcNiNyDQslcAQl8+trgk+BxS+y8CQEywTW8ntgEiHb/zSNUd4ozduMa1
YtkeFSkJl7dycgN29IXcdVz8TZGbvsviSY4kIWD1o8vOV0Z6iQjdy68ZmRcCQDgN
sy6B8LbPaY5WY4hqqoKD/IN1W5naNYhmaz4oR9FjkT6bzASypwXb10zK1WtjNOrb
IQm8SBbMAMXzJ65zmoECQQDEQGLmGGA9fl+X5j92RXZCLsyx+dcj9mhgsFm5KeRv
v2xJkFEjQq3a/7mTk4Fd/iNMJCERjfa4EcAHBEHctEyn`;
